import React, { useState } from 'react';
import { MdPhoneIphone, MdSecurity } from 'react-icons/md';
import toast from 'react-hot-toast';
import { validatePhone } from '../../services/rgpdService';
import CopyrightInfo from '../Common/CopyrightInfo';

export default function RGPDValidatePhone({ token, maskedPhone, clientName, onNext }) {
  const [lastDigits, setLastDigits] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await validatePhone(token, lastDigits);
      toast.success('Código OTP enviado por SMS.');
      onNext();
    } catch {
      toast.error('Dígitos incorretos ou token inválido.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="text-center">
      <div className="flex justify-center items-center rounded-md bg-green-100 py-3 px-6 text-green-800 mb-6">
        <MdSecurity className="h-5 w-5 text-green-700 mr-2" />
        <span className="font-bold text-base md:text-base text-xs">
          Valide a sua identidade para prosseguir com a assinatura RGPD.
        </span>
      </div>

      <p className="text-gray-700 text-base mb-2">
        Confirme os últimos <strong>3 dígitos</strong> do seu número de telemóvel:
      </p>
      <p className="font-mono text-lg mb-4">{maskedPhone}</p>

      <input
        type="text"
        maxLength={3}
        value={lastDigits}
        onChange={(e) => setLastDigits(e.target.value.replace(/\D/g, ''))}
        className="border border-gray-300 text-center rounded-md p-2 w-24 text-lg font-bold tracking-widest"
      />

      <div>
        <button
          onClick={handleSubmit}
          disabled={loading || lastDigits.length !== 3}
          className={`mt-6 px-6 py-2 rounded-md text-white font-medium transition ${
            loading || lastDigits.length !== 3
              ? 'bg-gray-300 cursor-not-allowed'
              : 'bg-[#26A4BB] hover:bg-[#0C92AF]'
          }`}
        >
          {loading ? 'A Enviar...' : 'Validar'}
        </button>
      </div>

      <div className="mt-10 text-gray-600 text-sm flex justify-center items-center">
        <MdPhoneIphone className="mr-1 text-gray-500" />
        O código será enviado para o número indicado.
      </div>

      <CopyrightInfo className="mt-10" />
    </div>
  );
}